import { $el, bind, getStrTypeAttr, removeAttrs } from '../../dom-utils';
import { type, validComps } from '../../utils';
var CountDown = /** @class */ (function () {
    function CountDown() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-count-down', { all: true });
        this._create(this.COMPONENTS);
    }
    CountDown.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'count-down');
        var _countTime = CountDown.prototype._countTime;
        return {
            get endTime() {
                return '';
            },
            set endTime(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                _countTime(target, newVal);
            },
            events: function (_a) {
                var onStop = _a.onStop;
                if (!onStop)
                    return;
                bind(target, 'DOMNodeInserted', function (e) {
                    if (e.target.textContent === '00:00:00') {
                        type.isFn(onStop, true);
                    }
                });
            }
        };
    };
    CountDown.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var endTime = _this._attrs(node).endTime;
            _this._countTime(node, endTime);
            removeAttrs(node, ['endTime']);
        });
    };
    CountDown.prototype._countTime = function (node, endTime) {
        if (!endTime)
            return;
        var timer = null;
        var countDown = function () {
            //获取当前时间
            var date = new Date();
            var now = date.getTime();
            //设置截止时间
            var endDate = new Date(endTime);
            var _endTime = endDate.getTime();
            //时间差
            var diff = _endTime - now;
            //定义变量 d,h,m,s保存倒计时的时间
            var d = 0, h = 0, m = 0, s = 0;
            if (diff >= 0) {
                d = Math.floor(diff / 1000 / 60 / 60 / 24);
                h = Math.floor((diff / 1000 / 60 / 60) % 24);
                m = Math.floor((diff / 1000 / 60) % 60);
                s = Math.floor((diff / 1000) % 60);
            }
            var checkTime = function (t) {
                if (t < 10)
                    t = "0" + t;
                return t;
            };
            //将0-9的数字前面加上0，例1变为01
            d = checkTime(d);
            h = checkTime(h);
            m = checkTime(m);
            s = checkTime(s);
            node.textContent = h + ":" + m + ":" + s;
        };
        countDown();
        timer = window.setInterval(countDown, 1000);
        bind(node, 'DOMNodeInserted', function (e) {
            if (e.target.textContent === '00:00:00') {
                window.clearInterval(timer);
                return;
            }
        });
    };
    CountDown.prototype._attrs = function (node) {
        return {
            endTime: getStrTypeAttr(node, 'end-time', '')
        };
    };
    return CountDown;
}());
export default CountDown;
